import type {PropsWithChildren} from 'react';

import styles from './tooltip-avatar.module.css';

export const TooltipAvatar = ({children}: PropsWithChildren<unknown>) => <div className={styles.root}>{children}</div>;
